import React from 'react';
import { useAuth } from './AuthProvider.jsx';
import Login from './Login.jsx';
import PageSkeleton from '../components/ui/PageSkeleton.jsx';

/**
 * Wrap protected routes with <RequireAuth>…</RequireAuth>
 * - Waits for auth `ready` before deciding
 * - If authenticated → render children
 * - If not → render <Login /> inline (no redirect), preserving the current URL on refresh
 */
export default function RequireAuth({ children }) {
  const { user, ready, enabled } = useAuth();

  // Hold the page's frame until Firebase resolves initial auth state. This
  // used to `return null`, which meant a white flash before
  // RequireSubscription's own loading state before the page's — three empty
  // states back to back on every protected route.
  if (!ready) return <PageSkeleton label="Loading your account" />;

  // Do not navigate; show Login inline on the same route
  if (enabled && !user) {
    return <Login />;
  }

  return <>{children}</>;
}